import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import PrevArrowSVG from '../../components/SVG';
import NextArrowSVG from '../../components/SVG/NextArrowSVG';
import SingleTeam from '../../components/Team/SingleTeam';

import teamImg1 from '../../assets/img/team/team-1-1.jpg';
import teamImg2 from '../../assets/img/team/team-1-2.jpg';
import teamImg3 from '../../assets/img/team/team-1-3.jpg';

const Team = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '3',
    spaceBetween: 35,
    autoplay: {
      delay: 3000,
    },
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: {
      prevEl: '.slider-prev',
      nextEl: '.slider-next',
    },
  };

  return (
    <div id="it-team" className="it-team-area fix it-team-style-2 pb-120">
      <div className="container">
        <div className="it-team-title-wrap mb-65">
          <div className="row align-items-end">
            <div className="col-xl-7 col-lg-7 col-md-6">
              <div className="it-team-title-box">
                <span className="it-section-subtitle tertiary">Doctor</span>
                <h3 className="it-section-title">
                  How I Work To <br /> improve Hospital
                </h3>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-6">
              <div className="it-team-arrow-box text-md-end">
                <button className="slider-prev">
                  <span>
                    <PrevArrowSVG />
                  </span>
                </button>
                <button className="slider-next">
                  <span>
                    <NextArrowSVG />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="it-team-wrapper">
              <div className="swiper-container">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  {...sliderOption}
                  className="swiper-wrapper it-team-active"
                >
                  <SwiperSlide className="swiper-slide">
                    <SingleTeam
                      teamImage={teamImg1}
                      titleClass="hover-anim tertiary"
                      authorName="Dr. Keely Evans"
                      specialist="Cardiologist"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTeam
                      teamImage={teamImg2}
                      titleClass="hover-anim tertiary"
                      authorName="Dr. David Kim"
                      specialist="Gynecologist"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTeam
                      teamImage={teamImg3}
                      titleClass="hover-anim tertiary"
                      authorName="Dr. Robert Jones"
                      specialist="Gynecologist"
                    />
                  </SwiperSlide>
                  <SwiperSlide className="swiper-slide">
                    <SingleTeam
                      teamImage={teamImg2}
                      titleClass="hover-anim tertiary"
                      authorName="Dr. David Kim"
                      specialist="Dentist"
                    />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
